import React from "react";
import { ButtonGroup, ButtonGroupProps } from "@emisgroup/ui-button";

interface CustomButtonGroupProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type BtnGrpProps = ButtonGroupProps & CustomButtonGroupProps;

/**
 * Responsible for rendering the button group
 * @returns the list of button element
 */
export const UIButtonGroup: React.FC<BtnGrpProps> = (props: BtnGrpProps) => {

  const { children } = props;
  return (
    <ButtonGroup
      {...props}
    >
      {children}
    </ButtonGroup>
  );
};
